/**
 * Shared state → colour palette for timesheet visualisations.
 * Used by the header widget rows, the Swimlane blocks, and the new
 * Daily Plan popup — so users read the same colour = the same state
 * across every surface.
 */

// Solid backgrounds (for swimlane blocks & stacked bars).
export const STATE_BLOCK = {
  planned:   { bg: "bg-amber-500/80",   border: "border-amber-600",   fg: "text-amber-950" },
  submitted: { bg: "bg-sky-500/80",     border: "border-sky-600",     fg: "text-white" },
  approved:  { bg: "bg-emerald-500/85", border: "border-emerald-700", fg: "text-white" },
  rejected:  { bg: "bg-rose-500/85",    border: "border-rose-700",    fg: "text-white" },
};

// Softer row tints (for tabular rows — widget popup, main grid).
export const STATE_ROW = {
  planned:   "bg-amber-50/60",
  submitted: "bg-sky-50/50",
  approved:  "bg-emerald-50/60",
  rejected:  "bg-rose-50/60",
};

// Chip / legend colours. Feb 2026 R104 · Bumped contrast in hover cards —
// the pale 50-tinted backgrounds were too subtle on the popover's white
// surface. Move to the 100 shade + darker text so users can scan states
// at a glance.
export const STATE_CHIP = {
  planned:   "border-amber-500 bg-amber-100 text-amber-900 font-semibold",
  submitted: "border-sky-500 bg-sky-100 text-sky-900 font-semibold",
  approved:  "border-emerald-500 bg-emerald-100 text-emerald-900 font-semibold",
  rejected:  "border-rose-500 bg-rose-100 text-rose-900 font-semibold",
};

export const STATE_LABEL = {
  planned:   "Planned",
  submitted: "Submitted",
  approved:  "Approved",
  rejected:  "Rejected",
};

export const STATE_ORDER = ["planned", "submitted", "approved", "rejected"];
